var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShow)?_c('b-tooltip',{attrs:{"label":_vm.$t('Orders.tooltipOp9'),"type":"is-dark"}},[_c('b-button',{staticClass:"local-lm-btn-row local-lm-block-action",attrs:{"icon-right":"close-circle"},on:{"click":function($event){$event.preventDefault();return _vm.callActions(_vm.supplierOrderID, _vm.modalActions)}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a1f9a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miscellaneous/BtnRejectOrder.vue
// module id = null
// module chunks = 